import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const updateRanking = async ({ data }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateRanking&companyid=${user.companyid}`,
      data,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response?.data?.error);
      throw error;
    });

  return response.data;
};

const useUpdateRankingMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateRanking,
    onSuccess: () => {
      queryClient.invalidateQueries(["ranking"]);
    },
    onError: (error) => {
      console.log("Error ", error.message);
    },
  });
};

export default useUpdateRankingMutation;
